export function getReadableDate(date){
    if(!date || date == "") return;
    
    // console.log(dateAsArray);
    let dateAsArray = date.split("-");

    if(dateAsArray.length != 3) return date;

    if(dateAsArray[2].length > 2){
        dateAsArray[2] = dateAsArray[2].substring(0, 2);
    }

    return (dateAsArray[2].length == 1 ? ("0" + dateAsArray[2]) : dateAsArray[2]) + "." + (dateAsArray[1].length == 1 ? ("0" + dateAsArray[1]) : dateAsArray[1]) + "." + dateAsArray[0];
}